/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Hero_EyebrowInputs */

const es_gift_hero_eyebrow = /** @type {(inputs: Gift_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjetas regalo`)
};

const gl_gift_hero_eyebrow = /** @type {(inputs: Gift_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarxetas agasallo`)
};

const en_gift_hero_eyebrow = /** @type {(inputs: Gift_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gift cards`)
};

/**
* | output |
* | --- |
* | "Gift cards" |
*
* @param {Gift_Hero_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_hero_eyebrow = /** @type {((inputs?: Gift_Hero_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Hero_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_hero_eyebrow(inputs)
	if (locale === "en") return en_gift_hero_eyebrow(inputs)
	return es_gift_hero_eyebrow(inputs)
});